import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {RolesActions} from '../store';
import {RolesSelectors} from '../store/selectors';

@Injectable()
export class RolesLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadRolesDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadRolesDone() {
    return this.store.pipe(
      select(RolesSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(RolesActions.ReadRoles());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
